module.exports = __webpack_public_path__ + "static/media/5.948235dc.svg";